import React from 'react';
import { Helmet } from 'react-helmet-async';

const ContactSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "Airport Parking Deals",
      "url": "https://airportparkingdeals.co.uk",
      "logo": "https://airportparkingdeals.co.uk/logo.webp",
      "description": "Compare and book cheap airport parking across all major airports. Best deals on Park & Ride, Meet & Greet, and Onsite parking.",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+44-3301332989",
          "contactType": "Customer Service",
          "areaServed": "GB",
          "availableLanguage": ["English"],
          "contactOption": "TollFree"
        },
        {
          "@type": "ContactPoint",
          "email": "info@dummy.co.uk",
          "contactType": "Customer Support",
          "areaServed": "GB",
          "availableLanguage": ["English"]
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "123 Parking Street",
        "addressLocality": "London",
        "addressRegion": "Greater London",
        "postalCode": "SW1A 1AA",
        "addressCountry": "GB"
      },
      "sameAs": [
        "https://facebook.com/airportparkingdeals",
        "https://twitter.com/airportparkingdeals",
        "https://linkedin.com/company/airportparkingdeals"
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ContactSchema;

